module.exports = __webpack_public_path__ + "carousel_04_img_02.png?43c93fe14d9bf9ba672ad4ef2c57ba98";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel_04_img_02.png
// module id = 157
// module chunks = 0